import React from 'react';
import {notifyError, notifySuccess, useAppDispatch} from "@nutastic/nutastic-react-app";
import FormFieldsEditor from "../../../refactor/formFields/FormFieldsEditor";
import {quickCall} from "../../../state/actions.mjs";
import makeFetchCall from "../../../utils/makeFetchCall";

const UserInformationForm = ({ formValues, onClose }) => {
    const appDispatch = useAppDispatch();

    const onSaveClick = ({ email, firstName, lastName }) => {
        const onComplete = (response) => {
            console.log('User updated', response);
            notifySuccess('User info updated :-)');
            onClose();
        }
        appDispatch(quickCall({
            title: 'Updating user information',
            asyncFetchCall: async () => {
                return await makeFetchCall('/api/account/update-info', { email, firstName, lastName })
            },
            onSuccess: onComplete,
            onError: () => notifyError(null, null, 'Failed to update...')
        }));
    };

    const userFormConfig = [{
        fields: [
            {
                id: 'firstName',
                label: 'First Name',
                type: 'Input',
            },
            {
                id: 'lastName',
                label: 'Last Name',
                type: 'Input',
            },
            {
                id: 'email',
                label: 'Email',
                type: 'Input',
                props: {
                    type: 'email'
                }
            }
        ]
    }];

    return <section className="accountsFormWrapper">
        <p>Change the fields below and click save to update your account information.</p>
        <FormFieldsEditor
            formConfig={userFormConfig}
            formData={formValues}
            className="accountsForm"
            onCancel={onClose}
            onSave={onSaveClick}
        />
    </section>;
};

export default UserInformationForm;
